import React, { useState, useEffect } from 'react';
import {
  Wrapper,
  Container,
  Title,
  Subtitle,
  Row,
  Form,
  Progress,
  Column,
  Label,
  ValidateNumber,
  HeaderWrapper,
  BackButton,
  StyledChevronLeft,
} from './styles';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import InputComponent from '../../components/Input';
import Button from '../../components/Button';
import ComboBox from '../../components/ComboBox';
import ValidateModal from '../../components/Modal/ValidateModal';
import OptionValidateModal from '../../components/Modal/OptionValidateModal';
import {
  formatTelephone,
  formatTelephoneReverse,
  formatCEP,
} from '../../services/utils/formatTELandCEP';
import {
  getUserConfirmedData,
  setUserConfirmedData,
  cleanTelephoneCredential,
} from '../../store/auth/actions';
import Toast from '../../components/Toast';
import { toast } from 'react-toastify';
import { page, generateNewTelephone } from '../../store/auth/actions';
import { navigationUrl } from '../../store/analytic/actions';
import { estadosBrasileiros } from '../../services/utils/states';
import { useHistory } from 'react-router-dom';

type TypeOptions = {
  whatsApp: boolean;
  sms: boolean;
};

const Profile: React.FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    user,
    cpf,
    updateProfile,
    userConfirmedData,
    telephoneAccept,
  } = useSelector((state: ApplicationState) => {
    return {
      user: state.auth.user?.nome,
      cpf: state.auth.user?.cpf,
      updateProfile: state.auth.updateProfile,
      userConfirmedData: state.auth.userConfirmedData,
      telephoneAccept: state.auth.telephoneAccept,
      telTokenError: state.auth.telTokenError,
    };
  });
  const [errors, setErrors] = useState({
    erroTelefone: false,
    erroLogradouro: false,
    erroBairro: false,
    erroNumero: false,
    erroEstado: false,
    erroCidade: false,
    erroTipo: false,
  });

  const [validateModal, setValidateModal] = useState(false);
  const [optionsModal, setOptionsModal] = useState(false);
  const [optionToValidate, setOptionToValidate] = useState<TypeOptions>({
    whatsApp: false,
    sms: false,
  });
  const [email, setEmail] = useState(userConfirmedData?.email || '');
  const [telephone, setTelephone] = useState(
    `${userConfirmedData?.ddd_tel ? userConfirmedData?.ddd_tel?.trim() : ''}${
      userConfirmedData?.telephone ? userConfirmedData?.telephone?.trim() : ''
    }`
  );
  const [cleanTel, setCleanTel] = useState('');
  const [cep, setCep] = useState(userConfirmedData?.cep || '');
  const [logradouro, setLogradouro] = useState(
    userConfirmedData?.publicPlace || ''
  );
  const [bairro, setBairro] = useState(userConfirmedData?.neighborhood || '');
  const [number, setNumber] = useState(userConfirmedData?.number || '');
  const [complement, setComplement] = useState(
    userConfirmedData?.complement || ''
  );
  const [region, setRegion] = useState(userConfirmedData?.state);
  const [addressType, setAddressType] = useState(
    userConfirmedData?.addressType
  );
  const [city, setCity] = useState(userConfirmedData?.city || '');
  const [inputPhone, setInputPhone] = useState<string>('');
  const percentage = useSelector(
    (state: ApplicationState) => state.auth.percentage
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(page('perfil'));
    dispatch(
      navigationUrl.request({
        action: '/abreCadastro',
      })
    );
  }, [dispatch]);

  useEffect(() => {
    telephoneAccept && setOptionsModal(false);
  }, [telephoneAccept]);

  useEffect(() => {
    if (updateProfile) {
      toast.error(
        <Toast title={'Perfil atualizado!'} type={'success'} description={''} />
      );
      dispatch(getUserConfirmedData.request());
      dispatch(setUserConfirmedData.failure(''));
    }
  }, [dispatch, updateProfile]);

  const handleDateValue = () => {};

  const handlerOptionModal = () => {
    const tel = formatTelephoneReverse(telephone);
    if (tel.length === 11) {
      setErrors({
        ...errors,
        erroTelefone: false,
      });
      setCleanTel(tel);
      dispatch(cleanTelephoneCredential());

      setOptionsModal(true);
    } else {
      setErrors({
        ...errors,
        erroTelefone: true,
      });
    }
  };

  useEffect(() => {
    const optionSelected = optionToValidate.whatsApp
      ? 'whatsapp'
      : optionToValidate.sms
      ? 'sms'
      : '';
    if (optionSelected) {
      dispatch(
        generateNewTelephone.request({
          type: optionSelected,
          telephone: cleanTel,
        })
      );
      setValidateModal(true);
    }
  }, [optionToValidate, dispatch, cleanTel]);

  useEffect(() => {
    validateModal && setOptionsModal(false);
  }, [validateModal]);

  const handleDateExit = () => {};

  const submit = (): void => {
    //declarando uma auxiliar pois o setErrors nao atualiza a "errors" no mesmo momento e não da pra utilizar no if la de baixo
    let errorValidation = {
      erroLogradouro: false,
      erroNumero: false,
      erroBairro: false,
      erroCidade: false,
      erroTipo: false,
      erroEstado: false,
    };

    if (cep.trim() !== '') {
      errorValidation = {
        erroLogradouro: logradouro.trim() === '',
        erroNumero: number.trim() === '',
        erroBairro: bairro.trim() === '',
        erroCidade: city.trim() === '',
        erroTipo:
          !addressType ||
          ((addressType && (addressType as any) === '#') as boolean),
        erroEstado: !region || ((region && (region as any) === '#') as boolean),
      };
      setErrors({
        ...errors,
        ...errorValidation,
      });
    } else {
      setErrors({
        ...errors,
        ...errorValidation,
      });
    }

    if (
      errorValidation.erroBairro ||
      errorValidation.erroCidade ||
      errorValidation.erroEstado ||
      errorValidation.erroLogradouro ||
      errorValidation.erroNumero ||
      errorValidation.erroTipo
    ) {
      return;
    }

    const data = {
      cpf: cpf,
      nome: user,
      cep: cep.replace(/\D/g, ''),
      state: (region as any) === '#' ? null : region,
      publicPlace: logradouro,
      number,
      complement,
      neighborhood: bairro,
      city: city,
      email,
      addressType: (addressType as any) === '#' ? null : addressType,
    } as GQL.IUserInput;
    dispatch(setUserConfirmedData.request({ data }));
    dispatch(
      navigationUrl.request({
        action: '/atualizaCadastro',
      })
    );
  };

  const logradouroInput = () => {
    return (
      <Column size={48}>
        <Label>Logradouro:</Label>
        <InputComponent
          value={logradouro}
          handlerOnchange={(e) => setLogradouro(e.target.value)}
          error={errors.erroLogradouro}
          type={'text'}
          errorMessage={'Campo obrigatório'}
          height={'48px'}
          placeholder={'Ex: Rua Senador Vergueiro'}
          onBlur={handleDateExit}
        />
      </Column>
    );
  };

  const bairroInput = () => {
    return (
      <Column size={100}>
        <Label>Bairro:</Label>
        <InputComponent
          value={bairro}
          handlerOnchange={(e) => setBairro(e.target.value)}
          error={errors.erroBairro}
          type={'text'}
          errorMessage={'Campo obrigatório'}
          height={'48px'}
          placeholder={'Ex: Botafogo'}
          onBlur={handleDateExit}
        />
      </Column>
    );
  };

  const emailInput = () => {
    return (
      <Column size={100}>
        <Label>E-mail:</Label>
        <InputComponent
          value={email}
          handlerOnchange={(e) => setEmail(e.target.value)}
          error={false}
          type={'text'}
          placeholder={'Informe seu E-mail'}
          errorMessage={'Campo inválido'}
          height={'48px'}
          onBlur={handleDateExit}
        />
      </Column>
    );
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Wrapper>
      <Container>
        <HeaderWrapper>
          <BackButton onClick={handleGoBack}>
            <StyledChevronLeft />
            Voltar
          </BackButton>
          <Title>Meu Perfil</Title>
        </HeaderWrapper>
        <Row>
          <Form>
            <div className='row'>
              <Column size={48}>
                <Label>Nome Completo:</Label>
                <InputComponent
                  value={user}
                  handlerOnchange={handleDateValue}
                  error={false}
                  type={'text'}
                  errorMessage={'Campo inválido'}
                  height={'48px'}
                  readOnly={true}
                  onBlur={handleDateExit}
                />
              </Column>

              <Column size={48}>
                <Label>CPF:</Label>
                <InputComponent
                  value={cpf}
                  handlerOnchange={handleDateValue}
                  error={false}
                  type={'text'}
                  errorMessage={'Campo inválido'}
                  height={'48px'}
                  readOnly={true}
                  onBlur={handleDateExit}
                />
              </Column>
            </div>
            <Subtitle>Contato</Subtitle>
            <div className='row-mob'>{emailInput()}</div>
            <div className='row-number'>
              <div className='row-desk'>{emailInput()}</div>

              <Column width={60} size={32}>
                <Label>Telefone (celular):</Label>
                <InputComponent
                  value={formatTelephone(telephone) || ''}
                  handlerOnchange={(e) => setTelephone(e.target.value)}
                  error={errors.erroTelefone}
                  type={'text'}
                  errorMessage={'Telefone inválido'}
                  height={'48px'}
                  placeholder={'Preencha seu celular'}
                  telephoneAccept={telephone.length > 0 && telephoneAccept}
                  maxLength={15}
                  onBlur={handleDateExit}
                  focus={inputPhone}
                />
              </Column>
              <ValidateNumber onClick={handlerOptionModal}>
                Validar celular
              </ValidateNumber>
            </div>
            <Subtitle>Endereço</Subtitle>
            <div className='row'>
              <Column size={48}>
                <Label>CEP:</Label>
                <InputComponent
                  value={formatCEP(cep)}
                  handlerOnchange={(e) => setCep(e.target.value)}
                  error={false}
                  type={'text'}
                  errorMessage={'Campo obrigatório'}
                  height={'48px'}
                  maxLength={9}
                  placeholder={'Digite o CEP'}
                  onBlur={handleDateExit}
                />
              </Column>
              {logradouroInput()}
            </div>

            <div className='row-number top'>
              <Column width={45} size={22}>
                <Label>Número:</Label>
                <InputComponent
                  value={number}
                  handlerOnchange={(e) => setNumber(e.target.value)}
                  error={errors.erroNumero}
                  type={'text'}
                  errorMessage={'Campo obrigatório'}
                  height={'48px'}
                  placeholder={'Número'}
                  onBlur={handleDateExit}
                />
              </Column>
              <Column width={45} size={22}>
                <Label>Complemento:</Label>
                <InputComponent
                  value={complement}
                  handlerOnchange={(e) => setComplement(e.target.value)}
                  error={false}
                  type={'text'}
                  errorMessage={'Campo inválido'}
                  height={'48px'}
                  placeholder={'Complemento'}
                  onBlur={handleDateExit}
                />
              </Column>

              <div className='row-desk'>{bairroInput()}</div>
            </div>

            <div className='row-mob'>{bairroInput()}</div>

            <div className='row top'>
              <Column size={48}>
                <Label>Estado:</Label>
                <ComboBox
                  value={region}
                  change={setRegion}
                  options={estadosBrasileiros()}
                  error={errors.erroEstado}
                  errorMessage={'Campo obrigatório'}
                  height={'52px'}
                />
              </Column>

              <Column size={48}>
                <Label>Cidade:</Label>
                <InputComponent
                  value={city}
                  handlerOnchange={(e) => setCity(e.target.value)}
                  error={errors.erroCidade}
                  type={'text'}
                  errorMessage={'Campo obrigatório'}
                  height={'48px'}
                  placeholder={'Cidade'}
                  onBlur={handleDateExit}
                />
              </Column>
            </div>

            <div className='row top'>
              <Column size={48}>
                <Label>Tipo:</Label>
                <ComboBox
                  value={addressType}
                  change={setAddressType}
                  options={[
                    { key: 1, value: 'Residencial' },
                    { key: 2, value: 'Comercial' },
                  ]}
                  error={errors.erroTipo}
                  errorMessage={'Campo obrigatório'}
                  height={'52px'}
                />
              </Column>
            </div>
          </Form>
          <Progress percentage={percentage}>
            {percentage !== 100 ? (
              <div className='progress-bar'>
                <CircularProgressbar
                  value={percentage}
                  strokeWidth={8}
                  text={`${percentage}%`}
                  styles={buildStyles({
                    textColor: '#222',
                    textSize: 24,
                    pathColor: theme.colors.primary,
                    trailColor: theme.colors.primaryLight,
                  })}
                />
              </div>
            ) : (
              <div className='complete'>{percentage}%</div>
            )}
            <h2 className='name'>Olá, {user}</h2>
            <p className='warning'>
              Seu perfil está {percentage}% completo.{' '}
              {percentage !== 100 &&
                `Preencha os dados que estão faltando para alcançar 100%.`}
            </p>
          </Progress>
        </Row>
        <Button
          height={60}
          color='primary'
          transform={true}
          fontSize='16'
          borderRadios='16'
          onClick={submit}
        >
          Salvar
        </Button>
      </Container>

      {optionsModal && (
        <OptionValidateModal
          optionToValidade={setOptionToValidate}
          handlerClose={() => setOptionsModal(false)}
          setAutoFocus={setInputPhone}
          telephone={cleanTel}
        />
      )}

      {validateModal && (optionToValidate.whatsApp || optionToValidate.sms) && (
        <ValidateModal
          telephone={cleanTel}
          handlerClose={() => setValidateModal(false)}
          optionChecked={optionToValidate}
          setAutoFocus={setInputPhone}
        />
      )}
    </Wrapper>
  );
};

export default Profile;
